const ColumnId = {
  bezeichnung: '0',
  LEISTUNG: '1',
  E_Z_EVU: '2',
  E_N: '3',
  PR: '4',
  G_M: '5',
  VFG: '6',
  E_SIM_DIFF_PERC: '7',
  alarmsToday: '8',
  alarmsYesterday: '9',
  alarmsLastWeek: '10',
  E_SIM: '12',
  DATAINPUT: '13',
  LAST_DATAINPUT_LOCALTIME: '14',
  STATUS: '15',
  EPI: '16',
  LOCAL_TIMEZONE_OFFSET: '17',
  SPECIFIC_YIELD_SIMULATED: '18',
  INVERTER_EVALUATION: '19',
  G_M_SAT: '20',
};

export default ColumnId;
